/*
 * Crossfade rotation for sections/text-image-grid.liquid grid image slots.
 * Only touches slots marked [data-eig-rotate] (2+ images added to that
 * Grid image block).
 *
 * One shared clock per .eig-grid, not one timer per slot: on every tick it
 * advances exactly one rotating slot, round-robin, then moves on. The
 * "Image rotation speed" setting is that gap between changes - not a
 * per-slot cycle length - so at most one image in the grid is ever
 * crossfading at a time, evenly spaced, regardless of how many slots have
 * extra images. The clock only runs while the grid is on screen, and
 * nothing runs at all if the visitor has asked for reduced motion.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var grids = document.querySelectorAll('.eig-grid:not([data-eig-inited])');
  if (!grids.length) return;

  grids.forEach(function (grid) {
    grid.setAttribute('data-eig-inited', 'true');

    var slotEls = grid.querySelectorAll('[data-eig-rotate]');
    var rotators = [];
    slotEls.forEach(function (item) {
      var images = item.querySelectorAll('.eig-grid__img');
      if (images.length > 1) {
        rotators.push({ images: images, activeIndex: 0, interval: item.getAttribute('data-eig-interval') });
      }
    });

    if (!rotators.length) return;

    var gap = parseInt(rotators[0].interval, 10) || 3500;
    var pointer = 0;
    var timer = null;

    function advanceOne() {
      var r = rotators[pointer];
      r.images[r.activeIndex].classList.remove('is-active');
      r.activeIndex = (r.activeIndex + 1) % r.images.length;
      r.images[r.activeIndex].classList.add('is-active');
      pointer = (pointer + 1) % rotators.length;
    }

    function start() {
      if (timer) return;
      timer = window.setInterval(advanceOne, gap);
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              start();
            } else {
              stop();
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(grid);
    } else {
      start();
    }
  });
})();
